//import { Component, OnInit } from '@angular/core';
import {Component,OnInit,Renderer,ViewChild} from '@angular/core';
import {FormBuilder,FormGroup,Validators,FormArray,FormControl,NgForm} from '@angular/forms';
//import { OrganisationsService } from 'src/app/_services/organisations.service';
//import{ OrganisationsService } from '.../';
import {OrganisationsService} from './../../_services/organisations.service';
import { Router, ActivatedRoute,Params  } from '@angular/router';
import {HttpHeaders} from '@angular/common/http';
import { ReversePipe } from './../../pipes/reverse.pipe';
import {INgxMyDpOptions, IMyDateModel} from 'ngx-mydatepicker';
import {MatSnackBar} from '@angular/material';
import { empty } from 'rxjs/observable/empty';
@Component({
 selector: 'app-addeditorganisation',
 templateUrl: './addeditorganisation.component.html',
 styleUrls: ['./addeditorganisation.component.css', './addeditorganisation.component.scss']
})



export class AddeditorganisationComponent implements OnInit {
contactsubmitdata=false
showorgindex:number
showorgindexcat:number

//username password start
cancelmodel:Boolean=false
newusewnamw:any
newpassword:any
//username password end

//delete data start
deleteindex:any
deleteday:any
deletestart:any
deleteend:any

workinghouresdelete:Boolean=false

//delete data end

modelcatlogo:Boolean=false

locationsubmitdata=false

    custom: any = {
        mon: "0",
        tue: "0",
        wen: "0",
        thu: "0",
        fri: "0",
        sat: "0",
        sun: "0",
        org_logo: ""
    }
    myOptions: INgxMyDpOptions = {
        dateFormat: 'dd-mm-yyyy',
        openSelectorTopOfInput:false
    };
    contactlocation:any={
        mobile1public:"0",
        mobile2public:"0",
        phone1public:"0",
        phone2public:"0",
        emailid1public:"0",
        emailid2public:"0"
    }

/*        variable for image delete start         */

deleteimageindex:any
deleteorg_image_id:any
deleteimagename:any


deleteimagecatindex:any
deleteorg_catimage_id:any
deleteimagecatname:any


getCountriesorg:any
statelistorg:any
citylistorg:any




/*  variable for image delete start  */


    modelFlag:Boolean=false

    modelcatToggle:Boolean=false


    productLoading:Boolean=false
    parentgetid:any
    onconvalueget=""
    organisationdataid=0
    //ravi new code 2-25-2019
    org_catelog_images_id:any
    org_catelog_name:any
    org_catelog_imageposition:any
    org_catelog_imgurl:any
    //ravi new code end 2-25-2019
    //4-1-2019
    dob_date=""
    submobile=""
    otperrormsg=""
    useraddresponse=""
    //4-1-2019
    org_id=0
    imageposition=""
    org_image_id=""
    suberror=""
    dob:any
    dob1:any
    org_working_hour_id=""
    datetime_status=""
    image_status=""
    image_name=""
    imagetype=""
    start_time=""
    end_time=""
    working_day=""
    dropdownSettings = {};
    dropdownSettingsorg={};
    responsedata = ""
    organisationid=0
    docimage=""
    orglist: any
    //new code 1-3-2019
    planlist:any;
    planId:any = 0;
    listSubscribedPlans:any
    listexistinguser:any
    //new code end 1-3-2019
    citylist: any
    statelist: any
    getCountries: any
    specialities: any
    locationDisabled:boolean = true;
    ContactDisabled:boolean=true;
    workingHoures:boolean=true
    SubscriptionDisabled:boolean=true;
    UserDisabled:boolean=true;
    selectedindex=0;
    organizationType:any;
    orgtypeselectedValue:any;
    public show: boolean = false;
    public subplan:boolean=true;
    public subplanlist:boolean=false;
    public userform:boolean=false;
    public userformsearch:boolean=true;
    constructor(private renderer: Renderer,
        private formBuilder: FormBuilder, 
        private orgservice: OrganisationsService,
        private router: Router,
        private route: ActivatedRoute,
        private snackbar:MatSnackBar
    ) {

    }
    public documentGrp: FormGroup;
    public locationgroup:FormGroup;
    public contactgroup:FormGroup;
    public Subscription:FormGroup
    public usergroup:FormGroup;
    public mobilesearch:FormGroup; 
    public contactsubmit:FormGroup;
    public totalfiles: Array < File > = [];
    public totalFileName = [];
    selectedItems = [];

    //ravi new code 2-25-2019 start
    public catfiles: Array < File > = [];
    public totalcatFileName = [];
    catselectedItems = [];
    //ravi new code end 2-25-2019
    //ravi new code 2-25-2019
    public catalogimg=0;
    //ravi new code start 2-25-2019

    public lengthCheckToaddMore = 0;
    public lengthCheckToaddMore1 = 0;
    org_specialities:{
        org_image_id:""
        image_type:""
        image_position:""
    }
    mobnumPattern = "^((\\+91-?)|0)?[0-9]{10}$"; 
    adminUserFlag:boolean = true;
    existUserReadonlyFlag:boolean = false;

    orglog:any

ngOnInit() {

        
    this.cancelmodel=false

        this.adminUserFlag=true
this.show=false

        this.documentGrp = this.formBuilder.group({
            org_name: '',
            refralcode:'',
            orgtype: '',
            orgstatus:'',
            org_logo: '',
            hidden_org_logo:'',
            ordanisationid: '',
            address1: '',
            address2: '',
            street: '',
            area: '',
            landmark: '',
            pincode: '',
            countryid: '',
            monworking: 0,
            tueworking: 0,
            wedworking: 0,
            thuworking: 0,
            friworking: 0,
            state_id: 0,
            satworking: 0,
            sunworking: 0,
            orgcheckbox:0,
            skills: [
                [], Validators.required
            ],
            documentFile: new FormControl(File),
            items: this.formBuilder.array([
                this.createUploadDocuments(this.org_image_id,this.image_name,
                this.imageposition,this.docimage,this.image_status,"editcall")
            ]),
            //items: this.formBuilder.array([this.createUploadDocuments(this.imageposition,this.imagetype,this.docimage,"editcall")]),
            org_catelog_images:this.formBuilder.array([
                this.org_catelog_imagesdata(this.org_catelog_images_id,
                this.org_catelog_name,this.imageposition,this.org_catelog_imgurl,"editcall")
            ]),
            doctorshadule: this.formBuilder.array([
                this.createdocDatetime(this.start_time,this.end_time,
                this.working_day,this.datetime_status,this.org_working_hour_id,"editcall")
            ])
        });
        //console.log("locationDisabled",this.locationDisabled)
        this.mobilesearch=this.formBuilder.group({
            mobilenumber:"" 
        })
        this.usergroup=this.formBuilder.group({
            mobilenumber:"",
            firstname:"",
            middlename:"",
            lastname:"",
            dob:"",
            otp:"", 
            gender:"",
            countryid:"",
            stateid:"",
            cityid:"",
            pincode:"",
            emailid:"", 
            isorgdefault:"",
            qtraquserid:""
        })
        
        this.locationgroup = this.formBuilder.group({
            countryid:['',[Validators.required]],
            state_id:['',[Validators.required]],
            city_id:['',[Validators.required]],
            address1:['',[Validators.required]],
            address2:[''],
            street:['',[Validators.required]],
            area:['',[Validators.required]],
            gpscords:[''],
            landmark:[''],
            pincode:['',[Validators.required]]
        })

/*
        this.QueueTempalteForm = this.formBuilder.group({
            queueTemplateName:['',[Validators.required]],
            queueTemplateImage:[''],
            servicetype:['',[Validators.required]],
            queueTemplateStatus:['Active',[Validators.required]],
          }); 
*/

        this.contactgroup=this.formBuilder.group({
          //  mobile1: ['',[Validators.required],[Validators.pattern('[0-9]+')]],
            
          mobile1:['', Validators.pattern(this.mobnumPattern)],
          mobile1public:0,
            mobile2:['', Validators.pattern(this.mobnumPattern)],
            mobile2public:0,
            phone1:[''],
            phone1public:0,
            phone2:[''],
            phone2public:0,
            emailid1:[''],
            emailid1public:0,
            emailid2:[''],
            emailid2public:0,
            website:['']
        })
        //console.log("this item",this.items)
       
        this.getcountry()
        this.getcountryorg()
        this.getOrganizationType()


        this.dropdownSettings = {
            singleSelection: false,
            idField: 'speciality_id',
            textField: 'speciality_name',
            selectAllText: 'Select All',
            unSelectAllText: 'UnSelect All',
            itemsShowLimit: 1,
            allowSearchFilter: true
        };

        this.dropdownSettingsorg = {
            singleSelection: true,
            idField: 'org_id',
            textField: 'org_name',
            allowSearchFilter: true
        };



        /*
        this.dropdownSettings = {
            singleSelection: true,
            idField: 'speciality_id',
            textField: 'speciality_name',
            selectAllText: 'Select All',
            unSelectAllText: 'UnSelect All',
            itemsShowLimit: 3,
            allowSearchFilter: true
        };
*/




        //edit part start
        this.route.params.subscribe(params => {
            if(this.route.snapshot.params.orgid){
                this.org_id = this.route.snapshot.params.orgid;
                this.organisationid = this.org_id;
                if(this.org_id != 0){
                    this.orgservice.checkadminuserexist(this.org_id).subscribe((response)=>{
                        if(response.status_code == 200){




//console.log("response.status_code",response.status_code)

/*
                            if(response.Data != null){
                                this.adminUserFlag = false;
                            }else{
                                this.adminUserFlag = true;
                            }
*/
//this.adminUserFlag = true;

this.adminUserFlag = false;

                        }else{


                            this.adminUserFlag = true;
                        
                        }


console.log("this.adminUserFlag",this.adminUserFlag)

                    })
                }
                //check admin exist
                // if(this.org_id != 0){
                //     this.orgservice.getProviderList(this.org_id).subscribe((response)=>{
                //         if(response.status_code == 200){
                //             if(response.Data != null && response.Data.length > 0){
                //                 this.adminUserFlag = false;
                //             }
                //         }else{
                //             this.adminUserFlag = true;
                //         }
                //     })
                // }else{
                //     this.adminUserFlag = true;
                // }
               
                this.orgservice.listSubscribedPlans(this.org_id).subscribe(data => {
                    if(data.status_code == 200){
                        this.subplan = true ; 
                        this.subplanlist = false;

console.log("data.Data",data.Data)

                        this.listSubscribedPlans = data.Data
                        if(data.Data != null){
                            this.UserDisabled=false;
                        }else{
                            this.UserDisabled=true;
                        }
                    }
                })
                this.orgservice.geteditorganisation(this.route.snapshot.params.orgid).subscribe(data => {
                this.org_id = this.route.snapshot.params.orgid    


if(data.Data.org_details[0].org_logo!="")
{
this.orglog=data.Data.org_details[0].org_logo
}

                console.log("response",data)

                this.documentGrp.controls['org_name'].setValue(data.Data.org_details[0].org_name);
                this.documentGrp.controls['refralcode'].setValue(data.Data.org_details[0].refralcode);
                
                this.documentGrp.controls['orgtype'].setValue(data.Data.org_details[0].org_type);

                this.documentGrp.controls['orgstatus'].setValue(data.Data.org_details[0].status);


                this.orgtypeselectedValue = data.Data.org_details[0].org_type;
                if(this.orgtypeselectedValue != "" && this.orgtypeselectedValue != undefined){
                    this.selectedItems=data.Data.org_specialities;
                    this.getSpecialities()
                }

// console.log("selected_type = ",this.orgtypeselectedValue );
// console.log("data.Data.org_details[0].parent_id",data.Data.org_details[0].parent_id)
if(data.Data.org_details[0].parent_id!=0){
//console.log("data.Data.org_details[0].parent_id",data.Data.org_details[0].parent_id)
this.documentGrp.controls['orgcheckbox'].setValue(true)
this.show=true
this.documentGrp.controls['ordanisationid'].setValue(data.Data.org_details[0].parent_id);
this.parentgetid=data.Data.org_details[0].parent_data
}
                this.documentGrp.controls['monworking'].setValue(data.Data.org_details[0].is_mon_working);
                this.documentGrp.controls['tueworking'].setValue(data.Data.org_details[0].is_tue_working);
                this.documentGrp.controls['wedworking'].setValue(data.Data.org_details[0].is_wed_working);
                this.documentGrp.controls['thuworking'].setValue(data.Data.org_details[0].is_thu_working);
                this.documentGrp.controls['friworking'].setValue(data.Data.org_details[0].is_fri_working);
                this.documentGrp.controls['satworking'].setValue(data.Data.org_details[0].is_sat_working);
                this.documentGrp.controls['sunworking'].setValue(data.Data.org_details[0].is_sun_working);
                

console.log("org_logo",data.Data.org_details[0].org_logo_url)

                this.custom.org_logo=data.Data.org_details[0].org_logo_url
                if(data.Data.org_images != null){
                    for(var i=0;i<(data.Data.org_images.length);i++){
                        this.items.insert(i, this.createUploadDocuments(
                        data.Data.org_images[i].org_image_id,
                        data.Data.org_images[i].image_name,    
                        data.Data.org_images[i].image_position,
                        data.Data.org_images[i].org_image_url,data.Data.org_images[i].image_status,""))
                        //console.log("image position",data.Data.org_images[i].image_position)
                        this.lengthCheckToaddMore = this.lengthCheckToaddMore + 1;
                    }
                }
                if(data.Data.org_catelog_images != null){
                    for(var k=0;k<(data.Data.org_catelog_images.length);k++){
                        this.org_catelog_images.insert(k, this.org_catelog_imagesdata(
                            data.Data.org_catelog_images[k].org_image_id,
                            data.Data.org_catelog_images[k].image_name,    
                            data.Data.org_catelog_images[k].image_position,
                            data.Data.org_catelog_images[k].org_image_url,"")
                        )
                        this.catalogimg = this.catalogimg + 1;
                    }
                }

                //console.log("this.items",this.items)
                if(data.Data.org_working_hrs != null){
                    for(var j=0;j<(data.Data.org_working_hrs.length);j++){

if(data.Data.org_working_hrs[j].working_day=="Mon")
{
                        this.doctorshadule.insert(j,this.createdocDatetime(
                            data.Data.org_working_hrs[j].start_time,
                            data.Data.org_working_hrs[j].end_time,
                            "Monday",
                            data.Data.org_working_hrs[j].working_hr_status,
                            data.Data.org_working_hrs[j].org_working_hour_id,
                            ""
                        ))
                        this.lengthCheckToaddMore1 = this.lengthCheckToaddMore1 + 1;
                    }
                    if(data.Data.org_working_hrs[j].working_day=="Tue")
                    {
                                            this.doctorshadule.insert(j,this.createdocDatetime(
                                                data.Data.org_working_hrs[j].start_time,
                                                data.Data.org_working_hrs[j].end_time,
                                                "Tuesday",
                                                data.Data.org_working_hrs[j].working_hr_status,
                                                data.Data.org_working_hrs[j].org_working_hour_id,
                                                ""
                                            ))
                                            this.lengthCheckToaddMore1 = this.lengthCheckToaddMore1 + 1;
                                        }
                                        if(data.Data.org_working_hrs[j].working_day=="Wed")
{
                        this.doctorshadule.insert(j,this.createdocDatetime(
                            data.Data.org_working_hrs[j].start_time,
                            data.Data.org_working_hrs[j].end_time,
                            "Wednesday",
                            data.Data.org_working_hrs[j].working_hr_status,
                            data.Data.org_working_hrs[j].org_working_hour_id,
                            ""
                        ))
                        this.lengthCheckToaddMore1 = this.lengthCheckToaddMore1 + 1;
                    }
                    if(data.Data.org_working_hrs[j].working_day=="Thu")
{
                        this.doctorshadule.insert(j,this.createdocDatetime(
                            data.Data.org_working_hrs[j].start_time,
                            data.Data.org_working_hrs[j].end_time,
                            "Thursday",
                            data.Data.org_working_hrs[j].working_hr_status,
                            data.Data.org_working_hrs[j].org_working_hour_id,
                            ""
                        ))
                        this.lengthCheckToaddMore1 = this.lengthCheckToaddMore1 + 1;
                    }
                    if(data.Data.org_working_hrs[j].working_day=="Fri")
{
                        this.doctorshadule.insert(j,this.createdocDatetime(
                            data.Data.org_working_hrs[j].start_time,
                            data.Data.org_working_hrs[j].end_time,
                            "Friday",
                            data.Data.org_working_hrs[j].working_hr_status,
                            data.Data.org_working_hrs[j].org_working_hour_id,
                            ""
                        ))
                        this.lengthCheckToaddMore1 = this.lengthCheckToaddMore1 + 1;
                    }
                    if(data.Data.org_working_hrs[j].working_day=="Sat")
{
                        this.doctorshadule.insert(j,this.createdocDatetime(
                            data.Data.org_working_hrs[j].start_time,
                            data.Data.org_working_hrs[j].end_time,
                            "Saturday",
                            data.Data.org_working_hrs[j].working_hr_status,
                            data.Data.org_working_hrs[j].org_working_hour_id,
                            ""
                        ))
                        this.lengthCheckToaddMore1 = this.lengthCheckToaddMore1 + 1;
                    }
                    if(data.Data.org_working_hrs[j].working_day=="Sun")
{
                        this.doctorshadule.insert(j,this.createdocDatetime(
                            data.Data.org_working_hrs[j].start_time,
                            data.Data.org_working_hrs[j].end_time,
                            "Sunday",
                            data.Data.org_working_hrs[j].working_hr_status,
                            data.Data.org_working_hrs[j].org_working_hour_id,
                            ""
                        ))
                        this.lengthCheckToaddMore1 = this.lengthCheckToaddMore1 + 1;
                    }           
                    
                    
                    }
                }



                this.locationDisabled=false
                this.ContactDisabled=false
                this.SubscriptionDisabled=false;
                this.workingHoures=false
                //console.log("item",this.items)
                //console.log("country_idcountry_id",data.Data.org_location_info[0].country_details[0].country_id)
                //console.log("country_idcountry_id",data.Data.org_location_info[0].state_details[0].state_id)
                //console.log("data.Data.org_location_info[0]",data.Data.org_location_info[0].country_id)
                if(data.Data.org_location_info[0].country_details!=null){
                    this.onconChange(data.Data.org_location_info[0].country_details[0].country_id)    
                }
                if(data.Data.org_location_info[0].state_details!=null){
                    this.onstateChange(data.Data.org_location_info[0].state_details[0].state_id)
                }

                



                this.locationgroup.controls['address1'].setValue(data.Data.org_location_info[0].address_1);
                this.locationgroup.controls['address2'].setValue(data.Data.org_location_info[0].address_2);
                this.locationgroup.controls['street'].setValue(data.Data.org_location_info[0].street);
                this.locationgroup.controls['area'].setValue(data.Data.org_location_info[0].area);
                this.locationgroup.controls['landmark'].setValue(data.Data.org_location_info[0].landmark);
                this.locationgroup.controls['pincode'].setValue(data.Data.org_location_info[0].pincode);

                this.locationgroup.controls['gpscords'].setValue(data.Data.org_location_info[0].gps_cords);



                if(data.Data.org_location_info[0].country_details!=null){
                    this.locationgroup.controls['countryid'].setValue(data.Data.org_location_info[0].country_details[0].country_id);
                }
                if(data.Data.org_location_info[0].state_details!=null){
                    this.locationgroup.controls['state_id'].setValue(data.Data.org_location_info[0].state_details[0].state_id);
                }
                if(data.Data.org_location_info[0].city_details!=null){
                    this.locationgroup.controls['city_id'].setValue(data.Data.org_location_info[0].city_details[0].city_id);
                }
                this.documentGrp.controls['hidden_org_logo'].setValue(data.Data.org_details[0].org_logo);
                //console.log("mobile1",data.Data.org_contact_info[0].mobile_1)
                //console.log("data.Data.org_contact_info",data.Data.org_contact_info)
                //console.log("data.Data.org_contact_info",data.Data.org_contact_info[0]['contact'])
                //console.log(data.Data.org_contact_info)

/*
console.log("data.Data.org_contact_info[1]['phone_no'])",data.Data.org_contact_info[0]['is_visibility'])
console.log("data.Data.org_contact_info[1]['phone_no'])",data.Data.org_contact_info[1]['is_visibility'])
console.log("data.Data.org_contact_info[1]['phone_no'])",data.Data.org_contact_info[2]['is_visibility'])
console.log("data.Data.org_contact_info[1]['phone_no'])",data.Data.org_contact_info[3]['is_visibility'])
console.log("data.Data.org_contact_info[1]['phone_no'])",data.Data.org_contact_info[4]['is_visibility'])
*/


               if(data.Data.org_contact_info[0]['phone_no']!=null)
                {
                this.contactgroup.controls['mobile1'].setValue(data.Data.org_contact_info[0]['phone_no']);
                }
                
               // if(data.Data.org_contact_info[0]['contact']!='')
              //  {
                this.contactgroup.controls['mobile1public'].setValue(data.Data.org_contact_info[0]['is_visibility']);
                //}
                
//console.log("data.Data.org_contact_info[1]['phone_no']",data.Data.org_contact_info[1]['phone_no'])


                if(data.Data.org_contact_info[1]['phone_no']!=null)
                {
                this.contactgroup.controls['mobile2'].setValue(data.Data.org_contact_info[1]['phone_no']);
                }
                
                
                //if(data.Data.org_contact_info[0]['contact']!='')
                //{
                this.contactgroup.controls['mobile2public'].setValue(data.Data.org_contact_info[1]['is_visibility']);
                //}
                
            
                if(data.Data.org_contact_info[2]['phone_no']!=null)
                {
                this.contactgroup.controls['phone1'].setValue(data.Data.org_contact_info[2]['phone_no']);
                }
                
                
                //if(data.Data.org_contact_info[0]['contact']!='')
                //{
                this.contactgroup.controls['phone1public'].setValue(data.Data.org_contact_info[2]['is_visibility']);
                //}
                
                if(data.Data.org_contact_info[3]['phone_no']!=null)
                {
                this.contactgroup.controls['phone2'].setValue(data.Data.org_contact_info[3]['phone_no']);
                }
                
                
                //if(data.Data.org_contact_info[0]['contact']!='')
                //{
                this.contactgroup.controls['phone2public'].setValue(data.Data.org_contact_info[3]['is_visibility']);
                //}
                if(data.Data.org_contact_info[4]['phone_no']!=null)
                {
                this.contactgroup.controls['emailid1'].setValue(data.Data.org_contact_info[4]['phone_no']);
                }
                
                //if(data.Data.org_contact_info[0]['contact']!='')
                //{
                this.contactgroup.controls['emailid1public'].setValue(data.Data.org_contact_info[4]['is_visibility']);
                //}
                
                if(data.Data.org_contact_info[5]['phone_no']!=null)
                {
                this.contactgroup.controls['emailid2'].setValue(data.Data.org_contact_info[5]['phone_no']);
                }
                //if(data.Data.org_contact_info[0]['contact']!='')
                //{
                this.contactgroup.controls['emailid2public'].setValue(data.Data.org_contact_info[5]['is_visibility']);
                //}
                

                console.log("data.Data.org_contact_info[0]['website']",data.Data.org_contact_info[0]['website'])

                if(data.Data.org_contact_info[6]['phone_no']!=null)
                {
                this.contactgroup.controls['website'].setValue(data.Data.org_contact_info[6]['phone_no']);
                }
            

                /*
                this.contactgroup.controls['mobile1public'].setValue(data.Data.org_location_details[0].mobile1_public);
                this.contactgroup.controls['mobile2'].setValue(data.Data.org_location_details[0].mobile_2);
                this.contactgroup.controls['mobile2public'].setValue(data.Data.org_location_details[0].mobile2_public);
                this.contactgroup.controls['phone1public'].setValue(data.Data.org_location_details[0].phone1_public);
                this.contactgroup.controls['phone2public'].setValue(data.Data.org_location_details[0].phone2_public);
                this.contactgroup.controls['emailid1public'].setValue(data.Data.org_location_details[0].email_id1_public);
                this.contactgroup.controls['emailid2public'].setValue(data.Data.org_location_details[0].email_id2_public);
                this.contactgroup.controls['phone1'].setValue(data.Data.org_location_details[0].phone_1);
                this.contactgroup.controls['phone2'].setValue(data.Data.org_location_details[0].phone_2);
                this.contactgroup.controls['emailid1'].setValue(data.Data.org_location_details[0].email_id1);
                this.contactgroup.controls['emailid2'].setValue(data.Data.org_location_details[0].email_id2);
                this.contactgroup.controls['website'].setValue(data.Data.org_location_details[0].website);
                */
                            
                /*
                this.contactgroup.controls['mobile1'].setValue(data.Data.org_contact_info[0].mobile_1);
                this.contactgroup.controls['mobile1public'].setValue(data.Data.org_contact_info[0].mobile1_public);
                this.contactgroup.controls['mobile2'].setValue(data.Data.org_contact_info[0].mobile_2);
                this.contactgroup.controls['mobile2public'].setValue(data.Data.org_contact_info[0].mobile2_public);
                this.contactgroup.controls['phone1public'].setValue(data.Data.org_contact_info[0].phone1_public);
                this.contactgroup.controls['phone2public'].setValue(data.Data.org_contact_info[0].phone2_public);
                this.contactgroup.controls['emailid1public'].setValue(data.Data.org_contact_info[0].email_id1_public);
                this.contactgroup.controls['emailid2public'].setValue(data.Data.org_contact_info[0].email_id2_public);
                this.contactgroup.controls['phone1'].setValue(data.Data.org_contact_info[0].phone_1);
                this.contactgroup.controls['phone2'].setValue(data.Data.org_contact_info[0].phone_2);
                this.contactgroup.controls['emailid1'].setValue(data.Data.org_contact_info[0].email_id1);
                this.contactgroup.controls['emailid2'].setValue(data.Data.org_contact_info[0].email_id2);
                this.contactgroup.controls['website'].setValue(data.Data.org_contact_info[0].website);
                */

                /*organisation new change  4-1-2019 start*/


                /*
                this.orgservice.getOrganisationLocContactDetails(this.route.snapshot.params.orgid)
                .subscribe(
                response => {
                this.contactgroup.controls['mobile1'].setValue(response.Data.org_location_details[0].mobile_1);
                this.contactgroup.controls['mobile1public'].setValue(response.Data.org_location_details[0].mobile1_public);
                this.contactgroup.controls['mobile2'].setValue(response.Data.org_location_details[0].mobile_2);
                this.contactgroup.controls['mobile2public'].setValue(response.Data.org_location_details[0].mobile2_public);
                this.contactgroup.controls['phone1public'].setValue(response.Data.org_location_details[0].phone1_public);
                this.contactgroup.controls['phone2public'].setValue(response.Data.org_location_details[0].phone2_public);
                this.contactgroup.controls['emailid1public'].setValue(response.Data.org_location_details[0].email_id1_public);
                this.contactgroup.controls['emailid2public'].setValue(response.Data.org_location_details[0].email_id2_public);
                this.contactgroup.controls['phone1'].setValue(response.Data.org_location_details[0].phone_1);
                this.contactgroup.controls['phone2'].setValue(response.Data.org_location_details[0].phone_2);
                this.contactgroup.controls['emailid1'].setValue(response.Data.org_location_details[0].email_id1);
                this.contactgroup.controls['emailid2'].setValue(response.Data.org_location_details[0].email_id2);
                this.contactgroup.controls['website'].setValue(response.Data.org_location_details[0].website);
                })
                */

                /*organisation new change end 4-1-2019 end*/
                })
            }


            
        })
        //end edit form
        this.getorglist()
console.log("this.show",this.show)

    }
    //ravi new code 19-12-2018
    createdocDatetime(start_time,end_time,working_day,datetimestatus,org_working_hour_id,editcheck): FormGroup {
        return this.formBuilder.group({
            timestart: start_time,
            timeend: end_time,
            timeday: working_day,
            datetime_status:datetimestatus,
            org_working_hour_id:org_working_hour_id,
            editcheck:editcheck
        });
    }

//org_image_id,image_name

    createUploadDocuments(org_image_id,image_name,imageposition,docimage,imagestatus,editcheck): FormGroup {
        return this.formBuilder.group({
            org_image_id:org_image_id,
            image_name:image_name,
            image_position: imageposition,
            documentFile: docimage,
            image_status:imagestatus, 
            editcheck:editcheck
        });
    }

//ravi new code 2-25-2019

    org_catelog_imagesdata(org_catelog_images_id,org_catelog_name,imageposition,imageurl,editcheck): FormGroup {
        return this.formBuilder.group({
            org_image_id:org_catelog_images_id,
            image_name:org_catelog_name,
            image_position: imageposition,
            imagecatFile: imageurl,
            editcheck:editcheck
        });
    }

//ravi new code end 2-25-2019
    getcountry() {
        this.orgservice.getCountries().subscribe(response => {
            this.getCountries = response.Data
            console.log("ddddddddddddddddd")

        });
    }

    onconChange(val) {
        this.onconvalueget = val
        this.orgservice.getState(val).subscribe(response => {
            this.statelist = response.Data
        });
    }

    onstateChange(val) {
        this.orgservice.getcity(val).subscribe(response => {
            this.citylist = response.Data
        });
    }

//new code
getcountryorg() {
    this.orgservice.getCountriesorg().subscribe(response => {

        this.getCountriesorg = response.Data

        console.log("this.getCountriesorg",this.getCountriesorg)

    });
}

onconChangeorg(val) {
    this.onconvalueget = val
    this.orgservice.getStateorg(val).subscribe(response => {
        this.statelistorg = response.Data
    });
}

onstateChangeorg(val) {
    this.orgservice.getcityorg(val).subscribe(response => {
        this.citylistorg = response.Data
    });
}


///new code end


    getorglist() {


console.log("this.org_id",this.org_id)

        if(this.org_id!=0)
    {
        this.orgservice.getparentidorganisation(this.org_id).subscribe(response => {
            this.orglist = response.Data
console.log("this.orglist",this.org_id)
       });
    
    }
    else
    {
        this.orgservice.getparentgetallorganisation().subscribe(response => {
            this.orglist = response.Data
console.log("this.orglist",this.orglist)
       });
    

    }

    }

    getSpecialities() {
        if(this.orgtypeselectedValue != ""){
            this.orgservice.getSpecialitiesWithServiceType(this.orgtypeselectedValue).subscribe((response) => {
                if(response.status_code == "200"){
                    this.specialities = response.Data
                    if(this.specialities.length <= 0){
                        this.specialities = [];
                        this.selectedItems = [];
                    }   
                }
            });
        } else{
            this.specialities = [];
            this.selectedItems = [];
        }
    }

    adddocDatetime(): void {

console.log("this.start_time",this.start_time)

console.log("this.end_time",this.end_time)

if((this.start_time!="")&&(this.end_time!=""))
{
 
    this.doctorshadule.insert(0, this.createdocDatetime(this.start_time,
    this.end_time,this.working_day,this.datetime_status,this.org_working_hour_id,""))
    }
 else
 {

  

    this.doctorshadule.insert(0, this.createdocDatetime("12:00:00",
        "23:00:00",this.working_day,this.datetime_status,this.org_working_hour_id,""))
 }          
        
        this.lengthCheckToaddMore1 = this.lengthCheckToaddMore1 + 1;
    }

    removedocDatetime(index: number) {


//if(timeday!="")
//{
//console.log("index",index)
//console.log("timestart",timestart)
//console.log("timeend",timeend)
//console.log("timeday",timeday)

 this.doctorshadule.removeAt(index);
 this.lengthCheckToaddMore1 = this.lengthCheckToaddMore1 - 1;
//}
//else
//{


//}
// this.doctorshadule.removeAt(index);
// this.lengthCheckToaddMore1 = this.lengthCheckToaddMore1 - 1;
}

    get items(): FormArray {
        return this.documentGrp.get('items') as FormArray;
    };
    get doctorshadule(): FormArray {
        return this.documentGrp.get('doctorshadule') as FormArray;
    };

    //ravi new code 2-25-2019 start
    addcatelogimg(): void {
        this.org_catelog_images.insert(0, this.org_catelog_imagesdata(this.org_catelog_images_id,this.org_catelog_name,this.imageposition,this.org_catelog_imgurl,""))
        this.catalogimg = this.catalogimg + 1;
    }
  
    removecatelogimg(index: number) {
        this.org_catelog_images.removeAt(index);
        this.catalogimg = this.catalogimg - 1;
    }
    get org_catelog_images(): FormArray {
        return this.documentGrp.get('org_catelog_images') as FormArray;
    };
    //ravi new code end 2-25-2019 end


    //ravi new code start 2-25-2019


    addorgcatimg(): void{
        this.org_catelog_images.insert(0, this.org_catelog_imagesdata(this.org_catelog_images_id,
        this.org_catelog_name,
        this.imageposition,this.org_catelog_imgurl,"tampimage"))
        this.catalogimg = this.catalogimg + 1;
    }

    //ravi new code 2-26-2019 start
    removeItem123(index: number,imagename){
        console.log("imagename",imagename)
    }


//cat image start

deletecatimage(index:number,org_image_id,imagename)
{
//catmodelFlag
this.showorgindexcat=index+1
this.deleteimagecatindex=index
this.deleteorg_catimage_id=org_image_id
this.deleteimagecatname=imagename
this.modelcatTogglefun("open")
}



carconfirm()
{
this.removeorgcatimgdata(this.deleteimagecatindex,this.deleteorg_catimage_id, this.deleteimagecatname)
}

catcancel()
{
    this.modelcatTogglefun("canel")   
}



//cat image end


deleteimage(index:number,org_image_id,imagename)
{

this.showorgindex=index+1

    this.deleteimageindex=index
    this.deleteorg_image_id=org_image_id
    this.deleteimagename=imagename
    this.modelToggle("open")
    
}


confirm()
{
this.removeItemexist(this.deleteimageindex,this.deleteorg_image_id, this.deleteimagename)
}

cancel()
{
    this.modelToggle("canel")   
}

deleteimageno()
{
    this.deleteimageindex=""
    this.deleteorg_image_id=""
    this.deleteimagename=""

}





    
    removeItemexist(index:number,org_image_id,imagename){
if((org_image_id!='')&&(imagename!='')){
            this.orgservice.deleteimage(this.org_id,org_image_id,imagename).subscribe(data =>{
                if(data.status_code==200){
                    this.totalfiles.splice(index);
                    this.totalFileName.splice(index);
                    this.items.removeAt(index);
                    this.lengthCheckToaddMore = this.lengthCheckToaddMore - 1;
                    this.snackbar.open(data.Metadata.Message,'', {
                        duration: 2000,
                        verticalPosition:"top",
                        extraClasses: ['bg-green']
                        
                    });
                }else{
                    this.snackbar.open(data.Metadata.Message,'', {
                        duration: 2000,
                        verticalPosition:"top",
                        extraClasses: ['bg-red']
                    });
                }
            })
        }else{
            this.totalfiles.splice(index);
            this.totalFileName.splice(index);
            this.items.removeAt(index);
            this.lengthCheckToaddMore = this.lengthCheckToaddMore - 1;
        }
        this.modelToggle("canel")   
    //removeItemexist
    }
    //ravi new code 2-26-2019 end
    removeorgcatimg(index: number) {
        //console.log("index",index)
        this.catfiles.splice(index);
        this.totalcatFileName.splice(index);
        this.org_catelog_images.removeAt(index);
        this.catalogimg = this.catalogimg - 1;
    }










    removeorgcatimgdata(index: number,org_image_id,imagename){
        if((org_image_id!=null)){
            this.orgservice.deleteimage(this.org_id,org_image_id,imagename).subscribe(data =>{
                if(data.status_code==200){
                    this.catfiles.splice(index);
                    this.totalcatFileName.splice(index);
                    this.org_catelog_images.removeAt(index);
                    this.catalogimg = this.catalogimg - 1;
                    this.snackbar.open(data.Metadata.Message,'', {
                        duration: 2000,
                        verticalPosition:"top",
                        extraClasses: ['bg-green']
                    });
                }else{
                    this.snackbar.open(data.Metadata.Message,'', {
                        duration: 2000,
                        verticalPosition:"top",
                        extraClasses: ['bg-red']
                    });
                }
            })
        }else{
            this.catfiles.splice(index);
            this.totalcatFileName.splice(index);
            this.org_catelog_images.removeAt(index);
            this.catalogimg = this.catalogimg - 1;
        }
        this.modelcatTogglefun("canel")  
    }



    removeravicall(index: number){
        console.log("removeravicall","removeravicall")
    }

    //ravi new code end 2-25-2019
    addItem(): void {
        this.items.insert(0, this.createUploadDocuments(this.org_image_id,this.image_name,this.imageposition,this.docimage,this.image_status,""))
        // this.items.insert(0, this.createUploadDocuments(this.imageposition,this.imagetype,this.docimage,""))
        this.lengthCheckToaddMore = this.lengthCheckToaddMore + 1;
    }

    removeItem(index: number) {
        this.totalfiles.splice(index);
        this.totalFileName.splice(index);
        this.items.removeAt(index);
        this.lengthCheckToaddMore = this.lengthCheckToaddMore - 1;
    }

    public fileSelectionEvent(fileInput: any, oldIndex) {


console.log("fileInput",fileInput)


if((fileInput.target.files[0].type=="image/jpeg")||(fileInput.target.files[0].type=="image/jpg")||(fileInput.target.files[0].type=="image/png"))
{
 
/*    console.log("imaggggggggggg")
}
else
{
console.log("jpggggggggg")

}
*/


//console.log("fileInput.target.files[0]",fileInput.target.files[0].type)


        if (fileInput.target.files && fileInput.target.files[0]){
            var reader = new FileReader();
            reader.onload = (event: any) => {}
            if (oldIndex == 0) {
                this.totalfiles.unshift((fileInput.target.files[0]))
                this.totalFileName.unshift(fileInput.target.files[0].name)
            }else{
                // let main_form: FormData = new FormData();
                this.totalfiles[oldIndex] = (fileInput.target.files[0]);
                if(this.org_id!=0){
                    this.totalFileName[oldIndex-1] = fileInput.target.files[0].name
                }else{
                    this.totalFileName[oldIndex] = fileInput.target.files[0].name
                }
                //console.log("totalFileName",oldIndex)
                //main_form.append("org_image[]",(fileInput.target.files[0]),
            }
            reader.readAsDataURL(fileInput.target.files[0]);
        }
        if(this.totalfiles != null){
            if (this.totalfiles.length == 1) {
                this.lengthCheckToaddMore = 1;
            }
        }
    }
    else
    {
        this.snackbar.open("Invalid file type selected. Please select *.png, *.jpg, *.jpeg files.",'', {
            duration: 2000,
            verticalPosition:"top",
            extraClasses: ['bg-red']
        });

    }


        //console.log("totalfiles",this.totalfiles)
    }

    //ravi new code 2-25-2019 start
    public catlogimgSelectionEvent(fileInputcat: any, oldIndexcat) {




console.log("fileInputcat.target.files",fileInputcat.target.files[0].type)

        if((fileInputcat.target.files[0].type=="image/jpeg")||(fileInputcat.target.files[0].type=="image/jpg")||(fileInputcat.target.files[0].type=="image/png"))
{
        if (fileInputcat.target.files && fileInputcat.target.files[0]) {
            var reader = new FileReader();
            reader.onload = (event: any) => {}
            if (oldIndexcat == 0) {
                this.catfiles.unshift((fileInputcat.target.files[0]))
                this.totalcatFileName.unshift(fileInputcat.target.files[0].name)
            }else{
                // let main_form: FormData = new FormData();
                this.catfiles[oldIndexcat] = (fileInputcat.target.files[0]);
                if(this.org_id!=0){
                    this.totalcatFileName[oldIndexcat-1] = fileInputcat.target.files[0].name
                }else{
                    this.totalcatFileName[oldIndexcat] = fileInputcat.target.files[0].name
                }
            }
            reader.readAsDataURL(fileInputcat.target.files[0]);
        }
        if(this.catfiles != null){
            if (this.catfiles.length == 1) {
                this.catalogimg = 1;
            }
        }
        
    }
    else
        {
            this.snackbar.open("Invalid file type selected. Please select *.png, *.jpg, *.jpeg files.",'', {
                duration: 2000,
                verticalPosition:"top",
                extraClasses: ['bg-red']
            });
    
        }

    }
//ravi new code end 2-25-2019 end
//ravi new code 2-26-2019
    OnSubmitWorking(formValue: any){
        
        this.productLoading=true 

        if(this.org_id!=0){
            this.organisationdataid=this.org_id
        }else{
            this.organisationdataid=this.organisationid
        }
        let main_form: FormData = new FormData();
        var timedate=0
        if(this.org_id==0){
            timedate= this.doctorshadule.length
        }else{
            timedate= this.doctorshadule.length-1
        }
        //console.log()
        for (let t = 0; t < (timedate); t++) {
            if(formValue.doctorshadule[t]['timestart']!=""){
var days=""

if(formValue.doctorshadule[t]['timeday']=="Monday")
{
     days="Mon"
}else if(formValue.doctorshadule[t]['timeday']=="Tuesday")
{
    days="Tue"
}
else if(formValue.doctorshadule[t]['timeday']=="Wednesday")
{
    days="Wed"
}
else if(formValue.doctorshadule[t]['timeday']=="Thursday")
{
    days="Thu"
}
else if(formValue.doctorshadule[t]['timeday']=="Friday")
{
    days="Fri"
}
else if(formValue.doctorshadule[t]['timeday']=="Saturday")
{
    days="Sat"
}
else if(formValue.doctorshadule[t]['timeday']=="Sunday")
{
    days="Sun"
}
               main_form.append("org_working_day["+t+"]", days)
                main_form.append("org_start_time["+t+"]", formValue.doctorshadule[t]['timestart'])
                main_form.append("org_end_time["+t+"]", formValue.doctorshadule[t]['timeend'])
            }
        }


        
        //console.log("org id",this.org_id)
        //console.log("this.organisationdataid",this.organisationdataid)
        this.orgservice.saveworkinghoures(this.organisationdataid,main_form).subscribe(data =>{
            if(data.status_code==200){
                this.selectedindex=4
                this.locationDisabled = false;
                this.productLoading =false
                // this.organisationid=data.Data   
                //this.lengthCheckToaddMore = this.lengthCheckToaddMore - 1;
                this.snackbar.open(data.Metadata.Message,'', {
                    duration: 2000,
                    verticalPosition:"top",
                    extraClasses: ['bg-green']
                });
            }else{

                this.productLoading =false
                
                this.snackbar.open(data.Metadata.Message,'', {
                    duration: 2000,
                    verticalPosition:"top",
                    extraClasses: ['bg-red']
                });
            }
        })
    }
    //console.log("formValue",formValue)
    //ravi new code end 2-26-2019
    onFileChanged(event) {


        if((event.target.files[0].type=="image/jpeg")||(event.target.files[0].type=="image/jpg")||(event.target.files[0].type=="image/png"))
        {

        this.custom.org_logo = event.target.files[0]
        }
else{

    this.snackbar.open("Invalid file type selected. Please select *.png, *.jpg, *.jpeg files.",'', {
        duration: 2000,
        verticalPosition:"top",
        extraClasses: ['bg-red']
    });
}


    }
    isAnswerProvided(eveb) {
        console.log(eveb)
    }
    notifyMe(event) {
        console.log("Event", event)
    }
    
    addprop1(event) {
        if (event.target.checked) {
            this.show = true
        } else {
            this.show = false
        }
    }

    public OnSubmit(formValue: any) {
         console.log("formValue",formValue);
        



if((this.show==true)&&(formValue.ordanisationid==undefined))
{

    this.snackbar.open("please select Parent Organisation",'', {
        duration: 2000,
        verticalPosition:"top",
        extraClasses: ['bg-red']
    });

return true;
}
        
this.productLoading=true

         if (formValue.monworking) {
            this.custom.mon = "1"
        }
        if (formValue.tueworking) {
            this.custom.tue = "1"
        }
        if (formValue.wedworking) {
            this.custom.wen = "1"
        }
        if (formValue.thuworking) {
            this.custom.thu = "1"
        }
        if (formValue.friworking) {
            this.custom.fri = "1"
        }
        if (formValue.satworking) {
            this.custom.sat = "1"
        }
        if (formValue.sunworking) {
            this.custom.sun = "1"
        }
        let main_form: FormData = new FormData();
        var imglen=0
        if(this.org_id==0){
            imglen= this.items.length
        }else{
            imglen= this.items.length-1
        }
        var catlen=0
        if(this.org_id==0){
            catlen = this.org_catelog_images.length
        }else{
            catlen = this.org_catelog_images.length-1
        }
        
        console.log("imglen",imglen)
        if(imglen!=0)
        {

            console.log("formValue.items",this.totalfiles)

        for (let j = 0; j < imglen; j++) {

            if(< File > this.totalfiles[j])
            {
            main_form.append("org_image_type["+j+"]", "org_pic")
            main_form.append("org_image_position["+j+"]", formValue.items[j]['image_position'])
            main_form.append("org_image_id["+j+"]", formValue.items[j]['org_image_id'])
            main_form.append("org_image_hidden["+j+"]", formValue.items[j]['image_name'])
            if(< File > this.totalfiles[j]){
                main_form.append("org_image["+j+"]",< File > this.totalfiles[j])
            }  
        }
        
        }
    }



console.log("catlen",catlen)

if(catlen!=0)
{
        for (let k = 0; k < catlen; k++) {

            if(< File > this.catfiles[k])
            {
            main_form.append("catelog_image_type["+k+"]",'service_catelog')
            main_form.append("catelog_image_position["+k+"]", formValue.org_catelog_images[k]['image_position'])
            if(formValue.org_catelog_images[k]['org_image_id']!=null){
                main_form.append("catelog_image_id["+k+"]", formValue.org_catelog_images[k]['org_image_id'])
            }

            if(formValue.org_catelog_images[k]['image_name']!=null){
                main_form.append("catelog_image_hidden["+k+"]", formValue.org_catelog_images[k]['image_name'])
            }
            if(< File > this.catfiles[k]){
                main_form.append("catelog_image["+k+"]",< File > this.catfiles[k])
            } 
        } 


        }
}


console.log("formValue.skills.length",formValue.skills)

if(formValue.skills!=null)
{
if(formValue.skills.length!=0)
{
        for (let k = 0; k < (formValue.skills.length); k++) {
            main_form.append("speciality_id[]", formValue.skills[k]['speciality_id'])
        }
    }  

}
        main_form.append("org_logo", this.custom.org_logo)
        main_form.append("hidden_org_logo", formValue.hidden_org_logo)

        main_form.append("orgname", formValue.org_name)
        main_form.append("refralcode", formValue.refralcode)



        //console.log("formValue.ordanisationid",formValue.ordanisationid.length)

if(this.org_id==0)
{
if(formValue.ordanisationid!=undefined)
{
    main_form.append("ordanisationid",formValue.ordanisationid[0].org_id)

}
}
else
{

console.log("formValue.ordanisationid",formValue.ordanisationid)

if(formValue.ordanisationid!=undefined)
{
var la= formValue.ordanisationid.length

       if((la=="0"))
        {
           
        }
        else
        {  
main_form.append("ordanisationid",formValue.ordanisationid[0].org_id)
        }
    }
    
    
    }


console.log("this.org_id",this.org_id)

        this.orgservice.organisation(this.org_id,main_form, formValue, this.custom).subscribe(data =>{
            
            this.productLoading=false
            console.log("data",data)
            
            if(data.status_code==200){



console.log("data.Data",data.Data)


console.log("this.selectedindex",this.selectedindex)

                this.selectedindex=1
                this.workingHoures = false;
                this.organisationid = data.Data;
                this.organisationdataid = data.Data;
               // this.org_id = data.Data;
                this.snackbar.open(data.Metadata.Message,'', {
                    duration: 2000,
                    verticalPosition:"top",
                    extraClasses: ['bg-green']
                });
            }else{
                this.snackbar.open(data.Metadata.Message,'', {
                    duration: 2000,
                    verticalPosition:"top",
                    extraClasses: ['bg-red']
                });
            }
        })

    }

    public LocationSubmit(formValue: any){


        this.locationsubmitdata = true;

       // console.log("this.contactgroup.invalid",this.contactgroup.invalid)
        
                if(this.locationgroup.invalid)
                {
                return;
                }




        this.productLoading=true
        if(this.org_id!=0){
            this.organisationdataid=this.org_id
        }else{
            this.organisationdataid=this.organisationid
        }
        this.orgservice.editorganisationlocation(this.organisationdataid, formValue).subscribe(data => {
            if(data.status_code==200){
                this.selectedindex=2
                this.ContactDisabled=false 
                this.productLoading=false 
            }else{
                this.productLoading=false 
                this.snackbar.open(data.Metadata.Message,'', {
                    duration: 2000,
                    verticalPosition:"top",
                    extraClasses: ['bg-red']
                });    
            }
        })
    }
    //set  second box start

    public ContactSubmit(formValue: any)
    {

        this.contactsubmitdata = true;

console.log("this.contactgroup.invalid",this.contactgroup.invalid)

        if(this.contactgroup.invalid)
        {
        return;
        }
       
        this.productLoading=true

console.log("this.contactsubmitdata",this.contactsubmitdata)


        if(formValue.mobile1public) {
            this.contactlocation.mobile1public="1"
        }
else
{
    this.contactlocation.mobile1public="0"
}

        if(formValue.mobile2public) {
            this.contactlocation.mobile2public="1"
        }
        else
        {
            this.contactlocation.mobile2public="0"   
        }
        if(formValue.phone1public) {
            this.contactlocation.phone1public="1"
        }      
        else
        {
            this.contactlocation.phone1public="0" 
        }
        if(formValue.phone2public) {
            this.contactlocation.phone2public="1"
        }
else
{
    this.contactlocation.phone2public="0"
}

        if(formValue.emailid1public) {
            this.contactlocation.emailid1public="1"
        }     
        else
        {
            this.contactlocation.emailid1public="0"
        }
        if(formValue.emailid2public) {
            this.contactlocation.emailid2public="1"
        }
        else
        {
            this.contactlocation.emailid2public="0"   
        }
        if(this.org_id!=0){
            this.organisationdataid=this.org_id
        }else{
            this.organisationdataid=this.organisationid
        }

        console.log("eeeeeeeeee")
        this.orgservice.editorganisationcontact(this.organisationdataid, formValue,this.contactlocation).subscribe(data => {
            if(data.status_code==200){
                this.productLoading=false
                this.selectedindex=3
                this.snackbar.open(data.Metadata.Message,'', {
                    duration: 2000,
                    verticalPosition:"top",
                    extraClasses: ['bg-green']
                });   
            }else{


console.log("data response",data)

                this.productLoading=false
                this.snackbar.open(data.Metadata.Message,'', {
                    duration: 2000,
                    verticalPosition:"top",
                    extraClasses: ['bg-red']
                });    
            }
        })
    
    }

    subplanclick(){
        if(this.planId <= 0 ){
            this.snackbar.open("Please Select your plan",'', {
                duration: 2000,
                verticalPosition:"top",
                extraClasses: ['bg-red']
            });   
            this.UserDisabled = true;
        }else{
            this.selectedindex = 5;
        }
    }

    onoganisationclick(org){
        //console.log("index",this.org_id)
        if(org.index !=0 ){
            if(this.org_id!=0){
                // this.orgservice.getOrganisationLocContactDetails(this.org_id).subscribe(data => {
                //     if(org.index==1){
                //         /*
                //         this.onconChange(data.Data.org_location_details[0].country_id)    
                //         this.onstateChange(data.Data.org_location_details[0].state_id)
                //         this.locationgroup.controls['address1'].setValue(data.Data.org_location_details[0].address_1);
                //         this.locationgroup.controls['address2'].setValue(data.Data.org_location_details[0].address_2);
                //         this.locationgroup.controls['street'].setValue(data.Data.org_location_details[0].street);
                //         this.locationgroup.controls['area'].setValue(data.Data.org_location_details[0].area);
                //         this.locationgroup.controls['landmark'].setValue(data.Data.org_location_details[0].landmark);
                //         this.locationgroup.controls['pincode'].setValue(data.Data.org_location_details[0].pincode);
                //         this.locationgroup.controls['countryid'].setValue(data.Data.org_location_details[0].country_id);
                //         this.locationgroup.controls['state_id'].setValue(data.Data.org_location_details[0].state_id);
                //         this.locationgroup.controls['city_id'].setValue(data.Data.org_location_details[0].city_id);
                //         */
                //     }else if(org.index==2){
                //         /*
                //         this.contactgroup.controls['mobile1'].setValue(data.Data.org_location_details[0].mobile_1);
                //         this.contactgroup.controls['mobile1public'].setValue(data.Data.org_location_details[0].mobile1_public);
                //         this.contactgroup.controls['mobile2'].setValue(data.Data.org_location_details[0].mobile_2);
                //         this.contactgroup.controls['mobile2public'].setValue(data.Data.org_location_details[0].mobile2_public);
                //         this.contactgroup.controls['phone1public'].setValue(data.Data.org_location_details[0].phone1_public);
                //         this.contactgroup.controls['phone2public'].setValue(data.Data.org_location_details[0].phone2_public);
                //         this.contactgroup.controls['emailid1public'].setValue(data.Data.org_location_details[0].email_id1_public);
                //         this.contactgroup.controls['emailid2public'].setValue(data.Data.org_location_details[0].email_id2_public);
                //         this.contactgroup.controls['phone1'].setValue(data.Data.org_location_details[0].phone_1);
                //         this.contactgroup.controls['phone2'].setValue(data.Data.org_location_details[0].phone_2);
                //         this.contactgroup.controls['emailid1'].setValue(data.Data.org_location_details[0].email_id1);
                //         this.contactgroup.controls['emailid2'].setValue(data.Data.org_location_details[0].email_id2);
                //         this.contactgroup.controls['website'].setValue(data.Data.org_location_details[0].website);
                //         */
                //     }
                // })
                /*
                else if(org.index==2)
                {
                }
                */
            }
            if(org.index == 3){
                //console.log("index",org.index)
                // this.orgservice.listSubscribedPlans(this.org_id).subscribe(data => {
                //     if(data.status_code==200){
                //         //    console.log("data",data)  
                //         //this.planlist=  
                //         console.log("subplan",this.subplan)
                //         this.subplan=true
                //         this.subplanlist=false
                //         this.listSubscribedPlans=data.Data
                //         console.log("data.Data ",data.Data)
                //     }else{
                //         //console.log("data",data)  
                //     }
                // })
            }
            if(org.index == 4){
                // console.log("index",org.index)
            }
        }
    }

    statuschangeimage(testid:any,status:any){
        this.orgservice.updateimagestatus(testid,status).subscribe(data => {
            if(data.status_code==200){
                this.snackbar.open(data.Metadata.Message,'', {
                    duration: 2000,
                    verticalPosition:"top",
                    extraClasses: ['bg-green']
                });
            }else{
                this.snackbar.open(data.Metadata.Message,'', {
                    duration: 2000,
                    verticalPosition:"top",
                    extraClasses: ['bg-red']
                }); 
            }
        })
    }

    //statuschangedatetime
    statuschangedatetime(testid,status){
        this.orgservice.updatedatetimestatus(testid,status).subscribe(data => {
            if(data.status_code==200){
                this.snackbar.open(data.Metadata.Message,'', {
                    duration: 2000,
                    verticalPosition:"top",
                    extraClasses: ['bg-green']
                });
            }else{
                this.snackbar.open(data.Metadata.Message,'', {
                    duration: 2000,
                    verticalPosition:"top",
                    extraClasses: ['bg-red']
                });  
            }
        })
    }

    planlistdata(){
        if(this.org_id!=0){
            this.organisationdataid=this.org_id
        }else{
            this.organisationdataid=this.organisationid
        }
        this.orgservice.getplandescription(this.organisationdataid).subscribe(data => {
            if(data.status_code==200){
                this.subplan=false
                this.subplanlist=true

console.log("data.Data ",data.Data)

                this.planlist=data.Data  
            }
            else
            {
                this.snackbar.open(data.Metadata.Message,'', {
                    duration: 2000,
                    verticalPosition:"top",
                    extraClasses: ['bg-red']
                });  

            }
        })
    }

    sublist(){
        if(this.org_id!=0){
            this.organisationdataid = this.org_id;
        }else{
            this.organisationdataid = this.organisationid;
        }
        this.subplan = true;
        this.subplanlist = false;
        this.orgservice.listSubscribedPlans(this.organisationdataid).subscribe(data => {
            if(data.status_code==200){


                console.log("data.Data",data.Data)

                this.listSubscribedPlans=data.Data;
            }
        })
    }

    /*
    updatedatetimestatus
    statuschange(testid,status){
        this.orgservice.updatestatus(testid,status).subscribe(data => {
            console.log("data",data);
            if(data.status_code==200){
                console.log("data",data)  
            }else{
                console.log("data",data)  
            }
        })
    }
    */

    /* sublist(){} */
    divclick(planid:any,startdate:any,enddate:any){
        if(this.org_id != 0){
            this.organisationdataid = this.org_id;
        }else{
            this.organisationdataid = this.organisationid;
        }
        this.orgservice.SubscribedPlans(this.organisationdataid,planid,startdate,enddate).subscribe(data => {
            if(data.status_code == 200){
                this.planId = planid;
                this.snackbar.open(data.Metadata.Message,'', {
                    duration: 2000,
                    verticalPosition:"top",
                    extraClasses: ['bg-green']
                });
                this.orgservice.listSubscribedPlans(this.organisationdataid).subscribe(data => {
                    if(data.status_code == 200){
                        this.subplan = true;
                        this.subplanlist = false;
                        this.listSubscribedPlans = data.Data
                    }
                })
            }else{
                this.planId = 0 ;
                this.snackbar.open(data.Metadata.Message,'', {
                    duration: 2000,
                    verticalPosition:"top",
                    extraClasses: ['bg-red']
                });
            }
        })
    }


    OnSearch(formValue: any){
        if(formValue.mobilenumber == ""){
            this.snackbar.open("Please Enter Mobile Number",'', {
                duration: 2000,
                verticalPosition:"top",
                extraClasses: ['bg-red']
            });
            return ;
        }
        this.orgservice.getQTRAQUserDetails(formValue.mobilenumber,this.organisationid).subscribe(data => {
            if(data.status_code==200){
               if(data.Data[0].useraccess=="Yes")
                {
                  this.snackbar.open( 'Mobile no. '+(formValue.mobilenumber+' of User '
                  +data.Data[0].first_name+' is already part of the system','', {
                    duration: 2000,
                    verticalPosition:"top",
                    extraClasses: ['bg-red']
                    }));
                }
                else
                {



                this.userformsearch = false;
                this.userform = true;
                this.onconChangeorg(data.Data[0].country_id); 
                this.onstateChangeorg(data.Data[0].state_id);



                this.usergroup.controls['mobilenumber'].setValue(data.Data[0].user_name);
                this.usergroup.controls['firstname'].setValue(data.Data[0].first_name);
                this.usergroup.controls['middlename'].setValue(data.Data[0].middle_name);
                this.usergroup.controls['lastname'].setValue(data.Data[0].last_name);
                this.usergroup.controls['pincode'].setValue(data.Data[0].pincode);
                this.usergroup.controls['countryid'].setValue(data.Data[0].country_id);
                this.usergroup.controls['stateid'].setValue(data.Data[0].state_id);
                this.usergroup.controls['cityid'].setValue(data.Data[0].city_id);
                this.usergroup.controls['emailid'].setValue(data.Data[0].email_id);
                this.usergroup.controls['isorgdefault'].setValue(data.Data[0].system_user);
                this.usergroup.controls['gender'].setValue(data.Data[0].gender);
                this.usergroup.controls['qtraquserid'].setValue(data.Data[0].user_master_id);
               
                this.existUserReadonlyFlag = true;
                // disabling inputs
                this.onconvalueget=data.Data[0].country_id;
                this.submobile=data.Data[0].user_name;
                this.dob=data.Data[0].dob.split('-');
                this.dob1= {  
                    date: {  
                        year: parseInt(this.dob[0]),  
                        month: parseInt(this.dob[1]),  
                        day: parseInt(this.dob[2])
                    },
                }
                this.usergroup.controls['dob'].setValue(this.dob1);
            }
            }else{
               // this.userform = true;
             //   this.existUserReadonlyFlag = null;
              //  this.usergroup.controls['mobilenumber'].setValue(formValue.mobilenumber);
              //  this.submobile = formValue.mobilenumber;
              //  this.userformsearch = false;


                this.snackbar.open(data.Metadata.Message,'', {
                    duration: 2000,
                   verticalPosition:"top",
              });

                    this.existUserReadonlyFlag = null;
                this.usergroup.controls['mobilenumber'].setValue(formValue.mobilenumber);
                this.submobile = formValue.mobilenumber;
                this.userformsearch = false;

               this.userform = true;

            
               
            }
        })
    }

    changeMobileNumber(){
         // enabling inputs
        this.existUserReadonlyFlag = null;
        this.usergroup.reset();
        this.userformsearch = true;
        this.userform = false;
    }

    OnUsersubmit(formValue: any){
        //console.log("mobilenumber",formValue.mobilenumber) 
        /*
        console.log("firstname",formValue.firstname) 
        console.log("middlename",formValue.middlename) 
        console.log("lastname",formValue.lastname) 
        console.log("dob",formValue.dob) 
        console.log("pincode",formValue.pincode) 
        console.log("countryid",formValue.countryid) 
        console.log("stateid",formValue.stateid) 
        console.log("cityid",formValue.cityid) 
        console.log("emailid",formValue.emailid) 
        console.log("gender",formValue.gender) 
        console.log("emailid",formValue.emailid) 
        http://attoinfotech.in/demo/qtraqservices/qtraqapi/addQTRAQUser
        */
        if(this.org_id!=0){
            this.organisationdataid=this.org_id;
        }else{
            this.organisationdataid=this.organisationid;
        }

        formValue.isorgdefault="Yes"

        this.orgservice.addQTRAQUserDetails(formValue,this.dob_date,this.organisationdataid).subscribe(data => {
            if(data.status_code==200){

                this.newusewnamw=data.Data.username
                this.newpassword=data.Data.password
                /*
                this.snackbar.open(data.Metadata.Message,'', {
                    duration: 2000,
                    verticalPosition:"top",
                    extraClasses: ['bg-green']
                });
                this.usergroup.reset();
                this.userformsearch = true;
                this.userform = false;
                setTimeout(() => {
                    this.router.navigate(['/organisation']);
                }, 3000);
          */

         if(this.newusewnamw==undefined)
         {
            this.snackbar.open(data.Metadata.Message,'', {
                duration: 2000,
                verticalPosition:"top",
                extraClasses: ['bg-green']
            });
            this.usergroup.reset();
            this.userformsearch = true;
            this.userform = false;
            setTimeout(() => {
                this.router.navigate(['/organisation']);
            }, 3000);
             //this.router.navigate(['/']);
         }
         else
         {
           this.cancelmodelToggle("open")
           this.snackbar.open(data.Metadata.Message,'', {
             duration: 2000,
             });
          
         }


          
            }else{

//this.useraddresponse = data.Metadata.Message;

this.snackbar.open(data.Metadata.Message,'', {
    duration: 2000,
    verticalPosition:"top",
    extraClasses: ['bg-red']
});
            
            }
        })
    }



    cancelmodelToggle(action:string){
        if(action == "open"){
        this.cancelmodel = true;
        }else{
          this.router.navigate(['/organisation']);
        this.cancelmodel = false;
        }
        }
      







    genetarotp(){
        if(this.onconvalueget == ""){
            this.snackbar.open("Please select country.",'', {
                duration: 2000,
                verticalPosition:"top",
                extraClasses: ['bg-red']
            }); 
            return;
        }
        this.orgservice.generateOtp(this.onconvalueget, this.submobile).subscribe(data => {
            if(data.status_code==200){
                //otp

//console.log("data",data)
this.snackbar.open(data.Metadata.Message,'', {
    duration: 2000,
    verticalPosition:"top",
    extraClasses: ['bg-red']
});
               // this.usergroup.controls['otp'].setValue(data.Data);
            }else{

/*
                this.otperrormsg = data.Metadata.Message;
  */
 this.snackbar.open(data.Metadata.Message,'', {
    duration: 2000,
    verticalPosition:"top",
    extraClasses: ['bg-red']
});

  

            
            
            
            }
        })
    }

    onStartDateChanged(event: IMyDateModel): void {
        if(event.formatted !== ''){
            this.dob_date=event.formatted
        }
    }
    //set second box end
    /* 09-04-2019 */
    getOrganizationType(){

        this.orgservice.getOrganizationTypeActive().subscribe((response)=>{
            this.organizationType = response.Data
       
       
       
        })
    }



    modelToggle(action:string){

if(action == "open"){
this.modelFlag = true;
    }else{
        this.modelFlag = false;
        }
        }


modelcatTogglefun(action:string)
{

    if(action == "open"){
        this.modelcatToggle = true;
            }else{
                this.modelcatToggle = false;
                }

}


deleteworking(index:number,start,end,day)
{

    this.deleteindex=index
    this.deleteday=day
    this.deletestart=start
    this.deleteend=end
  
    this.workinghourfun("open")

}


deleteworkingconform()
{



    this.doctorshadule.removeAt(this.deleteindex);
    this.lengthCheckToaddMore1 = this.lengthCheckToaddMore1 - 1;
    this.workinghourfun("close")

}

deleteworkingcancel()
{
    this.workinghourfun("cancel")  
}




deleteorg()
{
this.logofun("open")
}

logoconfirm()
{
this.orgservice.deleteorglogo(this.org_id).subscribe((response)=>{
if(response.status_code=="200")
{
this.logofun("cancel")
this.custom.org_logo=null
this.snackbar.open(response.Metadata.Message,'', {
        duration: 2000,
        verticalPosition:"top",
        extraClasses: ['bg-green']
    });
}
else
{
    this.snackbar.open(response.Metadata.Message,'', {
        duration: 2000,
        verticalPosition:"top",
        extraClasses: ['bg-red']
    });
}
})
}


logocancel()
{
    this.logofun("cancel")
}



logofun(action:string)
{

    if(action == "open"){
        this.modelcatlogo = true;
            }else{
                this.modelcatlogo = false;
                }

}








workinghourfun(action:string)
{

    if(action == "open"){
        this.workinghouresdelete = true;
            }else{
                this.workinghouresdelete = false;
                }

}



    /* 09-04-2019 */
}


// WEBPACK FOOTER //
// ./src/app/component/addeditorganisation/addeditorganisation.component.ts